"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsConfirmationUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var components_1 = require("../../../components");
var constants_1 = require("../../../constants");
var copy_1 = require("../../../copy");
var utils_1 = require("../../../utils");
var params_1 = require("../../../utils/params");
var MeterReadingsConfirmationUI_styled_1 = require("./MeterReadingsConfirmationUI.styled");
var components_2 = require("./components");
var SuccessfulReadingCopy = function (_a) {
    var meterReading = _a.meterReading, peakMeterReading = _a.peakMeterReading, offpeakMeterReading = _a.offpeakMeterReading, anytimeMeterReading = _a.anytimeMeterReading, heatingMeterReading = _a.heatingMeterReading, eveningAndWeekendMeterReading = _a.eveningAndWeekendMeterReading, solarMeterReading = _a.solarMeterReading, shoulderMeterReading = _a.shoulderMeterReading, controlledLoad1MeterReading = _a.controlledLoad1MeterReading, controlledLoad2MeterReading = _a.controlledLoad2MeterReading, controlledLoad3MeterReading = _a.controlledLoad3MeterReading, intervalMeterReading = _a.intervalMeterReading, fuelType = _a.fuelType, readingDate = _a.readingDate, meterNumOfDigits = _a.meterNumOfDigits, isPending = _a.isPending, isOMR = _a.isOMR, omrWindowEndDate = _a.omrWindowEndDate, hasPhotoError = _a.hasPhotoError, photoName = _a.photoName;
    var withLeadingZeros = function (value) {
        return (0, utils_1.applyLeadingZeros)(meterNumOfDigits, value);
    };
    var _b = (0, core_1.useComponents)(), Heading1 = _b.Heading1, P = _b.P;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var registerReads = (0, params_1.readsFromParamValues)({
        meterReading: meterReading,
        peakMeterReading: peakMeterReading,
        offpeakMeterReading: offpeakMeterReading,
        anytimeMeterReading: anytimeMeterReading,
        heatingMeterReading: heatingMeterReading,
        eveningAndWeekendMeterReading: eveningAndWeekendMeterReading,
        controlledLoad1MeterReading: controlledLoad1MeterReading,
        controlledLoad2MeterReading: controlledLoad2MeterReading,
        controlledLoad3MeterReading: controlledLoad3MeterReading,
        solarMeterReading: solarMeterReading,
        intervalMeterReading: intervalMeterReading,
        shoulderMeterReading: shoulderMeterReading,
    });
    var successfulReadingHeadingCopyKey = isOMR
        ? 'successfulOMRCopyHeading'
        : isPending
            ? 'pendingReadingCopyHeading'
            : 'successfulReadingHeading';
    var successfulReadingInfoCopyKey = isOMR
        ? 'successfulOMRInfo'
        : isPending
            ? 'successfulReadingInfoPending'
            : 'successfulReadingInfo';
    return (react_1.default.createElement("div", { "data-testid": "meter-confirm-success" },
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: successfulReadingHeadingCopyKey, values: { submittedFuelType: fuelType } })),
        react_1.default.createElement(core_1.Feature, { feature: "meterPhoto" }, function (enabled) {
            return enabled && isPending ? (
            //should be RegisterBackground
            react_1.default.createElement("div", null,
                photoName && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingPhotoError", values: { meterPhotoName: photoName } }))),
                hasPhotoError && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingPhotoError" }))))) : null;
        }),
        react_1.default.createElement(Copy, { copyKey: successfulReadingInfoCopyKey, values: { omrWindowEndDate: omrWindowEndDate } }),
        react_1.default.createElement(MeterReadingsConfirmationUI_styled_1.ReadingWrapper, null, registerReads.map(function (_a) {
            var timeOfUseLabel = _a.timeOfUseLabel, value = _a.value;
            return (react_1.default.createElement(components_1.RegisterReading, { "data-testid": "register-summary".concat(timeOfUseLabel ? "-".concat(timeOfUseLabel) : ''), key: "register-".concat(timeOfUseLabel), timeOfUseLabel: timeOfUseLabel, 
                // TODO check this is correct timezone
                date: (0, date_fns_tz_1.toDate)(new Date(readingDate)), meterReading: withLeadingZeros(value), isNew: true }));
        })),
        react_1.default.createElement(Copy, { copyKey: "successfulReading" })));
};
var showSupplyLink = function (supply) {
    if (!supply) {
        return false;
    }
    if ((0, utils_1.hasSubmittedReadingToday)(supply.readings)) {
        return false;
    }
    return (0, utils_1.canSubmitReads)(supply.states);
};
// Prompt user to submit a reading for their other supply with the same fuel.
var showSameFuelLink = function (supplies, fuel, nextElecSupplyIndex) {
    if (fuel === 'gas') {
        return false;
    }
    var nextSupply = (0, utils_1.getSupplyMeterInfo)(supplies, fuel, nextElecSupplyIndex);
    return showSupplyLink(nextSupply);
};
// Prompt user to submit a reading for their other fuel.
var showNextFuelLink = function (supplies, otherFuel) {
    return supplies[otherFuel].some(function (otherSupply) {
        return showSupplyLink(otherSupply);
    });
};
var MeterReadingsConfirmationUI = function (_a) {
    var _b;
    var searchParams = _a.searchParams, supplies = _a.supplies, fuel = _a.fuel;
    var otherFuel = fuel === 'gas' ? 'electricity' : 'gas';
    var _c = (0, core_1.useComponents)(), P = _c.P, Card = _c.Card, Stack = _c.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var supplyIndexParam = searchParams.get('supplyIndex');
    var supply = (0, utils_1.getSupplyMeterInfo)(supplies, fuel, supplyIndexParam ? parseInt(supplyIndexParam) : undefined);
    var totalElecSupplies = supplies.electricity.length;
    var nextElecSupplyIndex = (0, utils_1.getNextSupplyIndex)(supplyIndexParam, totalElecSupplies);
    var dateFromParam = searchParams.get('readingDate');
    var readingDate = (0, date_fns_1.format)(dateFromParam ? new Date(dateFromParam) : new Date(), constants_1.DATE_FORMAT);
    var isPending = searchParams.get('isPending') === 'true';
    var isOMR = searchParams.get('isOMR') === 'true';
    var hasPhotoError = searchParams.get('hasImgError') === 'true';
    var photoName = searchParams.get('meterPhotoName') || null;
    var meterData = supply ? (0, utils_1.getMeterReadAnalyticsData)(supply, fuel) : null;
    var omrWindowEndDate = supply
        ? (0, date_fns_1.format)((0, date_fns_1.addDays)(new Date(supply.startDate), constants_1.ONBOARDING_DAYS), constants_1.DATE_FORMAT)
        : 'unknown';
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READINGS_SUCCESSFUL_SUBMIT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b[analytics_subjects_1.KAPI_ONLY] = true, _b.meterData = meterData, _b) },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(SuccessfulReadingCopy, { meterReading: searchParams.get('meterReading'), offpeakMeterReading: searchParams.get('offpeakMeterReading'), peakMeterReading: searchParams.get('peakMeterReading'), anytimeMeterReading: searchParams.get('anytimeMeterReading'), heatingMeterReading: searchParams.get('heatingMeterReading'), solarMeterReading: searchParams.get('solarMeterReading'), shoulderMeterReading: searchParams.get('shoulderMeterReading'), controlledLoad1MeterReading: searchParams.get('controlledLoad1MeterReading'), controlledLoad2MeterReading: searchParams.get('controlledLoad2MeterReading'), controlledLoad3MeterReading: searchParams.get('controlledLoad3MeterReading'), eveningAndWeekendMeterReading: searchParams.get('eveningAndWeekendMeterReading'), intervalMeterReading: searchParams.get('intervalMeterReading'), fuelType: fuel, readingDate: readingDate, meterNumOfDigits: supply === null || supply === void 0 ? void 0 : supply.meterNumOfDigits, isPending: isPending, isOMR: isOMR, omrWindowEndDate: omrWindowEndDate, hasPhotoError: hasPhotoError, photoName: photoName }),
                    nextElecSupplyIndex !== null &&
                        showSameFuelLink(supplies, fuel, nextElecSupplyIndex) ? (react_1.default.createElement(P, null,
                        react_1.default.createElement(components_2.SameFuelReadingGuideLink, { fuel: fuel, supplyIndex: nextElecSupplyIndex },
                            react_1.default.createElement(Copy, { copyKey: "confirmationSendSameFuel", values: { fuel: fuel } })),
                        react_1.default.createElement(Copy, { copyKey: "skipNextReading" }))) : showNextFuelLink(supplies, otherFuel) ? (react_1.default.createElement(P, null,
                        react_1.default.createElement(components_2.NextFuelReadingGuideLink, { fuel: otherFuel },
                            react_1.default.createElement(Copy, { copyKey: "confirmationSendNextFuel", values: { otherFuel: otherFuel || '' } })),
                        react_1.default.createElement(Copy, { copyKey: "skipNextReading" }))) : (react_1.default.createElement(Copy, { copyKey: "backToMeterReadings" })))))));
};
exports.MeterReadingsConfirmationUI = MeterReadingsConfirmationUI;
